import React from 'react';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { TABLE_EMPTY_TABLE } from '../../libraries/texts';

const EmptyTable = props => {
  const { classes } = props;
  return (
    <TableBody>
      <TableRow key={`row-0`}>
        <TableCell colSpan="100" align="center" className={classes.emptyTable}>
          {TABLE_EMPTY_TABLE}
        </TableCell>
      </TableRow>
    </TableBody>
  );
};

EmptyTable.propTypes = {};

export default EmptyTable;
